// В.2.b: Ординатор (liv_ordinator, common, 1/1/6, stealth).
// [Аура]: лечит себя на +1 ХП и 2 случайных ДРУГИХ союзных юнитов на +1 ХП.
//   - Сам Ординатор лечится всегда.
//   - 2 случайных других — выбор из всех живых союзных юнитов на поле
//     (обе линии), исключая самого Ординатора. Если других <2 — лечит
//     сколько есть. Героя НЕ лечит.
//   - Через healUnit. В обоих раундах хил-прохода Ф3.
//   - Молчание блокирует — это уже в каркасе runLivLifeHealAuras.
//
// ВАЖНО: поле ability_summon=liv_ordinator в xlsx (если попадётся как
// опечатка автора) — игнорируем. Здесь регистрируем только passive,
// чтобы загрузчик НЕ ругался на passive. Если в xlsx есть summon —
// warn-unimplemented один раз сообщит об этом, и это нормально.

import { registerLivLifeHealAura } from './heal-auras.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { healUnit } from './heal.js';

export const CARD_ID = 'liv_ordinator';
const HEAL_AMOUNT = 1;

registerImplementedAbility(CARD_ID, 'passive');

registerLivLifeHealAura(CARD_ID, (state, card, _round) => {
  const me = state.players?.[card.ownerId];
  if (!me) return;
  // Сам всегда.
  healUnit(state, card, HEAL_AMOUNT, card);
  // 2 случайных других.
  const others = me.unitsOnField().filter(u => u !== card && u.isAlive());
  if (others.length === 0) return;
  const targets = pickRandomN(others, 2, state.rng);
  for (const t of targets) {
    healUnit(state, t, HEAL_AMOUNT, card);
  }
});

function pickRandomN(arr, n, rng) {
  const copy = [...arr];
  for (let i = 0; i < n && i < copy.length; i++) {
    const j = i + rng.int(copy.length - i);
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy.slice(0, Math.min(n, copy.length));
}
